jQuery(document).ready(function($) {
  $(document).on('down.zf.accordion', function(event, $el) {
    $('ul.accordion--read-more .button').text('Read Less')
  })

  $(document).on('up.zf.accordion', function(event, $el) {
    $('ul.accordion--read-more .button').text('Read More')
  })

  $('#filter-toggle-button').on('on.zf.toggler', function(event, $el) {
    event.target.innerHTML = 'Hide Filters'
  })

  $('#filter-toggle-button').on('off.zf.toggler', function(event, $el) {
    event.target.innerHTML = 'Show Filters'
  })

  $('#development-menu ul li').on('click touch', function() {
    // Listen for click on anchor link for mobile menu
    // Toggle button class
    $('.icon__development-menu').toggleClass('open')
    // Trigger menu toggle
    $('.outer-container-menu-links').foundation('toggleMenu')
  })

  $(document).on('toggled.zf.responsiveToggle', function(event, $el) {
    var target = $(event.target).data('responsive-toggle')
    if (target === 'top-bar-menu') {
      $('#development-register-interest').toggleClass('hide')
    }
  })

  $('.section__specification .switch-input').change(function() {
    if ($(this).is(':checked')) {
      $('#premium-specification').addClass('hide')
      $('#executive-specification').removeClass('hide')
    } else {
      $('#premium-specification').removeClass('hide')
      $('#executive-specification').addClass('hide')
    }
  })
})
